import React from 'react';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import { IconButton } from '@ha/dsl';
import { ChevronLeftIcon, ChevronRightIcon } from 'ha/ui/next/Icons';
import { ControlProps } from 'ha/components/next/Slider';

export const styles = createStyles({
  root: {
    boxShadow: '0 2px 9px 0 rgba(0, 0, 0, 0.11)',
  },
});

interface Props {
  direction: 'left' | 'right';
}

export const SliderControl: React.FC<Props & ControlProps & WithStyles> = ({
  previousSlide,
  nextSlide,
  direction,
  classes,
}) => {
  const isLeft = direction === 'left';

  return (
    <IconButton
      className={classes.root}
      onClick={isLeft ? previousSlide : nextSlide}
    >
      {isLeft ? (
        <ChevronLeftIcon
          color="secondary"
          data-test-locator="SliderControl Icon - Left"
        />
      ) : (
        <ChevronRightIcon
          color="secondary"
          data-test-locator="SliderControl Icon - Right"
        />
      )}
    </IconButton>
  );
};

export default withStyles(styles)(SliderControl);
